export default __webpack_public_path__ + "static/media/q10_step2.0dc170fb.png";